import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import Styles from './vm-button-link.scss';

@customElement('vm-button-link')
export class VmButtonLink extends LitElement {
    static styles = Styles;

    @property({ type: String }) href = '';
    @property({ type: String }) target = '';
    @property({ type: String }) rel = '';
    @property({ type: String }) title = '';
    @property({ type: String }) variant = '';
    @property({ type: String }) size = '';
    @property({ type: String }) custom = '';
    @property({ type: Boolean }) active = false;
    @property({ type: Boolean, attribute: 'min-width' }) minWidth = false;
    @property({ type: Boolean, attribute: 'full-width' }) fullWidth = false;

    get linkClasses() {
        const classes: Record<string, boolean> = {
            'vm-button': true,
            [`vm-button--${this.variant}`]: !!this.variant,
            [`vm-button--${this.size}`]: !!this.size,
            'vm-button--active': this.active,
            'vm-button--min-width': this.minWidth,
            'vm-button--full-width': this.fullWidth,
        };

        if (this.custom) {
            this.custom.split(/\s+/).forEach((customClass) => {
                if (customClass) {
                    classes[`vm-button--${customClass}`] = true;
                }
            });
        }

        return classes;
    }

    render() {
        return html`
            <a
                href=${ifDefined(this.href || undefined)}
                target=${ifDefined(this.target || undefined)}
                rel=${ifDefined(this.rel || undefined)}
                title=${ifDefined(this.title || undefined)}
                class=${classMap(this.linkClasses)}
                part="link"
            >
                <slot></slot>
            </a>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-button-link': VmButtonLink;
    }
}
